module.exports = __webpack_public_path__ + "static/media/personal-data-company.c6a6161a.svg";